import React from 'react'
import aboutMiddleSection from "../../../Asset/About/about-middle-section.jpg"
import aboutMiddleSectionMobile from "../../../Asset/About/about-middle-section-mobile.jpg"

const MidContent = () => {
    return (
        <>
            <div className='mt-20 bg-[var(--white)] py-20 p-4 text-[var(--dark-blue)]'>
                {/* Upper Text Here */}
                <div className='text-[1.55rem] md:text-3xl lg:text-4xl xl:text-5xl font-ClashGrotesk font-medium  md:text-justify mb-4 md:mb-12 md:pl-10'>
                    <p className='leading-[1.1] tracking-[0px]'>We take our fun very seriously. <br className='hidden md:block' />This will be a community like no other!</p>
                </div>

                {/* Image and Description Here */}
                <div className='flex flex-col md:flex-row p-2 text-justify gap-8 md:gap-4 w-full'>
                    {/* Image comes here */}
                    <div className='md:w-1/2  flex justify-center items-center'>
                        <img className='hidden md:block rounded-3xl w-[82%]' src={aboutMiddleSection} alt="About Middle Section" />
                        <img className='md:hidden w-full rounded-2xl' src={aboutMiddleSectionMobile} alt="About Middle Section Mobile" />
                    </div>

                    {/* Description Comes Here */}
                    <div className='md:w-1/2 flex flex-col justify-center items-start gap-2 md:gap-6 font-manrope font-medium text-base md:text-sm lg:text-base xl:text-xl md:pr-8 xl:pr-15 text-[var(--dark-blue)]'>
                        <p>It all started with an itch to do something big in sports, and after talking with a friend who shared my love for football, I decided it was time to stop just talking about our passion and do something about it. So, fueled by caffeine and a mix of genius and ridiculousness, I texted a few friends, told them they were now captains of football teams, and gave them nothing more than a date and location—without revealing what they were in for. </p>

                        <p>On the big day, torrential rain threatened to cancel everything, but to my surprise, people showed up, ready to play, soaked to the bone. We played through the rain, mud flying everywhere, and ended the night with cold beers and the realization that we weren’t just organizing a game—we were building a community.</p>

                        <p>That began as a rainy-day gamble has since evolved into a series of sports events where competition meets connection, and every match feels like a victory lap, no matter the score.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MidContent
